import { Product, User, Pagination } from "../types";
import Axios from "axios";
import { API_URL } from "../config/env";
import { transformProduct } from "./helpers";



export async function followBusiness(userId: number) {
  const {
    data: { data },
  } = await Axios.post(`${API_URL}/profile/followers/${userId}`, {});

  return data;
}

export async function unfollowBusiness(userId: number) {
  const {
    data: { data },
  } = await Axios.delete(`${API_URL}/profile/followers/${userId}`);
  return data;
}
